import { ReactComponent as InstagramIcon } from "../assets/svgs/instagram.svg";
import { ReactComponent as MailIcon } from "../assets/svgs/mail.svg";
import { ReactComponent as LinkedinIcon } from "../assets/svgs/linkedin.svg";
import { ReactComponent as XIcon } from "../assets/svgs/x.svg";
import { Link } from "react-router-dom";

function Footer() {
    return (
        <footer id="contacts" className="bg-light text-dark py-10 px-4 text-center">
            <div className="flex justify-center gap-4 mb-6
                            sm:gap-8">
                <a
                    href="https://www.instagram.com/4ai_tech/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-dark p-2 rounded-md hover:scale-105 transition sm:p-3"
                >
                    <InstagramIcon className="w-8 h-8 sm:w-10 sm:h-10 stroke-light"/>
                </a>
                <a
                    href="mailto:hello@4aitech.it"
                    className="bg-dark p-2 rounded-md hover:scale-105 transition sm:p-3"
                >
                    <MailIcon className="w-8 h-8 sm:w-10 sm:h-10 stroke-light"/>
                </a>
                <a
                    href="https://it.linkedin.com/company/4aitech"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-dark p-2 rounded-md hover:scale-105 transition sm:p-3"
                >
                    <LinkedinIcon className="w-8 h-8 sm:w-10 sm:h-10 stroke-light"/>
                </a>
                <a
                    href="https://x.com/4ai_tech"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-dark p-2 rounded-md hover:scale-105 transition sm:p-3"
                >
                    <XIcon className="w-8 h-8 sm:w-10 sm:h-10 stroke-light"/>
                </a>


            </div>
            <p className="text-[3vw] sm:text-[1.5vw] xl:text-[1vw] font-bold">
                Copyright © 2024 4AI | Via Minturno 61 – 00177 – Roma (RM) | P.IVA/CF · 17688181001 | REA · RM – 1835003
                | Capitale sociale € 10.000,00 i.v.
            </p>

            <Link
                to="/privacy"
                className="text-sm text-dark underline hover:opacity-70 transition"
            >
                Privacy Policy
            </Link>
        </footer>
    );
}

export default Footer;
